import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { MdCardMembership, MdOutlineAirplanemodeActive } from "react-icons/md";
import { BsCashCoin } from "react-icons/bs";
import { MdStars } from "react-icons/md";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { FaBriefcase, FaInfinity } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import FAQSchema from "../../FAQSchema";
import { motion } from "framer-motion";
import {
  FaSearchDollar,
  FaRegThumbsUp,
  FaShieldAlt,
  FaMousePointer,
  FaWpforms,
  FaFileUpload,
  FaTruck,
} from "react-icons/fa";
import {
  FaPlaneDeparture,
  FaGift,
  FaMoneyBillWave,
  FaSyncAlt,
  FaGlobe,
  FaHotel,
  FaSuitcaseRolling,
  FaMedal,
} from "react-icons/fa";
import {
  FaPlane,
  FaChair,
  FaChartBar,
  FaExchangeAlt,
  FaBalanceScale,
} from "react-icons/fa";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const Travel = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  // const location = useLocation()
  // console.log(location.state)
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
        // console.log("Card API Response:", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  const currentCards = CreditCardData.cards
    ?.filter((cards) => cards.category_name === "Travel")
    .slice(indexOfFirstCard, indexOfLastCard);
  console.log({ currentCards });

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      question: " What is the best travel credit card in India?",
      answer:
        "There is no one-size-fits-all card. The best travel card depends on your travel patterns, airline preference, and desired benefits. TheFinMaster.com helps you compare top cards to find the ideal match.",
    },
    {
      question: " Can I use a travel credit card for non-travel expenses?",
      answer:
        "Yes, travel cards can be used for all expenses. However, you earn the highest rewards on travel-related spends such as flights, hotels, and travel portal bookings.",
    },
    {
      question: " Do travel credit cards offer international lounge access?",
      answer:
        "Premium travel credit cards often provide complimentary access to international lounges via programs like Priority Pass or DreamFolks.",
    },
    {
      question: "Is there a foreign currency fee on travel credit cards?",
      answer:
        "Most standard cards charge ~3.5%, but travel cards often offer reduced or waived foreign transaction fees — ideal for global travelers.",
    },
    {
      question: "What are air miles and how do I redeem them?",
      answer:
        "Air miles are reward points you earn on travel spends. They can be redeemed for flight tickets, upgrades, or other travel-related perks through partner airlines or redemption portals.",
    },
    {
      question: "Can I get travel insurance with a credit card?",
      answer:
        "Yes, many travel credit cards include complimentary insurance covering flight delays, baggage loss, and overseas emergencies. The coverage varies by card.",
    },
    {
      question: "What credit score do I need for a travel credit card?",
      answer:
        "A good credit score of 700+ is generally preferred. However, some mid-tier travel cards may accept applicants with slightly lower scores.",
    },
    {
      question: "Does TheFinMaster.com issue travel credit cards?",
      answer:
        "No, TheFinMaster.com is not a credit card issuer. We provide trusted comparisons and insights to help you choose the best travel card. Once you’re ready to apply, we redirect you to the issuing bank’s official website for a secure application.",
    },

    {
      question:
        "Do travel credit cards offer complimentary hotel bookings or discounts?",
      answer:
        "Yes, many travel credit cards offer deals on hotel stays including complimentary nights, discounts, or exclusive access to partner hotel chains. These benefits vary by card and often require bookings through specified portals.",
    },
    {
      question:
        "Can I earn rewards on domestic as well as international travel?",
      answer:
        "Absolutely. Most travel credit cards provide rewards or air miles on both domestic and international bookings. Some cards even offer higher rewards for international transactions or bookings made through partner travel platforms.",
    },
    {
      question:
        "How are travel rewards different from regular credit card points?",
      answer:
        "Travel rewards are often in the form of air miles, hotel points, or travel-specific cashback. These are tailored for travel redemptions and typically offer better value on flights, hotel stays, or upgrades compared to generic reward points.",
    },
    {
      question:
        "Do travel credit cards offer priority boarding or seat upgrades?",
      answer:
        "Select premium travel credit cards provide perks like priority boarding, preferred seat selection, or upgrade vouchers. These benefits are often available through tie-ups with specific airlines.",
    },
    {
      question: "What is the joining fee for travel credit cards?",
      answer:
        "Joining fees vary depending on the card's benefits and category. Entry-level cards may start around ₹500, while premium travel credit cards can have fees ranging from ₹2,500 to ₹10,000 or more, often with welcome rewards that offset the cost.",
    },
    {
      question: "Are travel credit cards accepted worldwide?",
      answer:
        "Yes, most travel credit cards are powered by international networks like Visa, Mastercard, or American Express, making them widely accepted in India and abroad. Be mindful of foreign transaction charges if applicable.",
    },
    {
      question: "Do travel credit cards come with concierge services?",
      answer:
        "Premium travel cards often include concierge services that assist with travel bookings, reservations, and itinerary planning. This service adds convenience for frequent travelers looking for a hassle-free experience.",
    },
    {
      question: "Is there a limit on earning air miles or travel points?",
      answer:
        "Many cards do have caps on monthly or annual rewards, especially for promotional accelerated earning rates. Always check your card’s reward program terms for applicable limits.",
    },
    {
      question: "How do I track and redeem my travel rewards?",
      answer:
        "Most banks offer a dedicated travel portal or app section where you can view and redeem rewards. You can book flights, hotels, or convert miles into vouchers depending on the card’s reward system.",
    },
    {
      question:
        "Can I share or transfer my travel rewards with family or friends?",
      answer:
        "This depends on the credit card issuer. Some allow you to transfer miles to airline loyalty programs which may permit shared bookings, while others may restrict redemptions to the cardholder only.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const steps = [
    {
      icon: <FaSearchDollar className="h-6 w-6 text-orange-500" />,
      title: " Research and Compare",
      description:
        "Explore top-rated travel credit cards on TheFinMaster.com. Compare options based on international acceptance, rewards on flights/hotels, lounge access, and foreign transaction fee waivers.",
    },
    {
      icon: <FaRegThumbsUp className="h-6 w-6 text-green-500" />,
      title: "Choose the Right Card",
      description:
        "Select a card that suits your travel frequency, preferred airline or hotel chain, and lifestyle benefits like concierge services or travel insurance.",
    },
    {
      icon: <FaShieldAlt className="h-6 w-6 text-purple-600" />,
      title: "Check Eligibility",
      description:
        "Review the card issuer’s eligibility criteria — usually based on your income, employment, and credit score — to ensure you qualify.",
    },
    {
      icon: <FaMousePointer className="h-6 w-6 text-teal-500" />,
      title: "Click to Apply",
      description:
        "Once you've selected the right card, click ‘Apply Now’ to be redirected to the official bank or issuer’s website.",
    },
    {
      icon: <FaWpforms className="h-6 w-6 text-amber-500" />,
      title: "Fill in the Application",
      description:
        "Complete the form with your personal, employment, and financial information.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-pink-500" />,
      title: "Upload Required Documents",
      description:
        "Attach digital copies of your identity proof, address proof, PAN, and income documents as required by the issuer.",
    },
    {
      icon: <FaTruck className="h-6 w-6 text-blue-600" />,
      title: " Verification and Card Delivery",
      description:
        "After successful verification, the issuer will dispatch your card to your address, typically within 7–10 business days.",
    },
  ];

  const benefits = [
    {
      icon: <FaMoneyBillWave className="text-3xl text-yellow-500" />,
      title: "Cashback Offers",
      description:
        "Get up to 5% cashback on fuel purchases, especially when used at partnered stations.",
    },
    {
      icon: <FaSyncAlt className="text-3xl text-purple-600" />,
      title: "Annual Fee Waivers",
      description:
        "Enjoy annual fee reversals on meeting yearly spending thresholds, making the card practically free.",
    },
    {
      icon: <FaHotel className="text-3xl text-pink-500" />,
      title: "Hotel and Airline Privileges",
      description:
        "Enjoy special rates, free upgrades, early check-ins, or complimentary breakfasts at partner hotels and airlines.",
    },
    {
      icon: <FaMedal className="text-3xl text-amber-600" />,
      title: " Welcome and Renewal Bonuses",
      description:
        "Receive generous welcome rewards or bonus miles upon card activation or annual renewal, often enough to book your next trip!",
    },

    {
      icon: <FaGift className="text-3xl text-green-600" />,
      title: "Accelerated Travel Rewards",
      description:
        "Earn air miles, travel points, or reward points faster on flights, hotel bookings, and holiday packages booked through select portals or apps.",
    },

    {
      icon: <FaGlobe className="text-3xl text-red-500" />,
      title: " Foreign Currency Markup Waivers",
      description:
        "Some premium cards offer reduced or waived foreign transaction fees, making international spending more cost-effective.",
    },

    {
      icon: <FaSuitcaseRolling className="text-3xl text-indigo-500" />,
      title: " Travel Insurance and Emergency Support",
      description:
        "Get covered against flight delays, baggage loss, or medical emergencies with complimentary travel insurance bundled into your card.",
    },
    {
      icon: <FaPlaneDeparture className="text-3xl text-blue-600" />,
      title: "Complimentary Airport Lounge Access",
      description:
        "Many travel cards offer free access to domestic and international airport lounges, enhancing your airport experience with comfort and convenience",
    },
  ];

  const factors = [
    {
      icon: FaPlane,
      title: "Airline or Travel Partnerships",
      desc: "Check if the card is co-branded with an airline or hotel chain. Such cards offer better rewards and exclusive perks when you book with that brand.",
    },
    {
      icon: FaChair,
      title: " Airport Lounge Access",
      desc: "Access to domestic and international lounges is a major advantage. Ensure the number of complimentary visits suits your travel frequency.",
    },

    {
      icon: FaGlobe,
      title: "Foreign Transaction Fees",
      desc: "If you travel internationally, opt for cards with low or zero foreign currency markup to save on overseas purchases.",
    },
    {
      icon: FaChartBar,
      title: "Reward Structure",
      desc: "Analyze how fast you earn rewards on travel categories. Some cards offer 5x or more on flight, hotel, and travel portal bookings.",
    },
    {
      icon: FaExchangeAlt,
      title: "Redemption Flexibility",
      desc: "Ensure that the earned miles or points are easy to redeem — whether for flights, hotel stays, upgrades, or gift vouchers.",
    },
    {
      icon: FaShieldAlt,
      title: "Travel Insurance Coverage",
      desc: "Look for built-in insurance coverage that includes flight delay, baggage loss, trip cancellation, and overseas medical emergencies.",
    },

    {
      icon: FaBalanceScale,
      title: "Annual Fees vs. Benefits",
      desc: "Evaluate whether the annual fee is justified by the benefits. Many cards offer a fee waiver on hitting a spend milestone, making them cost-effective in the long run.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
          Top Travel Credit Cards in India – Rewards & Free Lounge Access
        </title>
        <meta
          name="description"
          content="Explore the best travel credit cards offering lounge access, air miles & exclusive travel benefits. Compare and apply online today."
        />
        <meta
          name="keywords"
          content="best travel credit card, best credit card for airline miles, best travel rewards credit card"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/credit-card/travel-credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        {/* <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
                <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
                    Travel Card
                </h1>
                <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
               
            </div> */}
            
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Travel Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>

        <div className="flex flex-wrap   justify-center gap-4 lg:gap-6 mt-4">
          <Link
            to="/credit-card/best-cashback-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsCashCoin className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Cash Back
              </span>
            </span>
          </Link>

          <Link
            to="/credit-card/fuel-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <BsFillFuelPumpFill className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Fuel
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-lifetime-free-credit-cards"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaInfinity className="mr-3 text-2xl text-black" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Lifetime Free
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/best-premium-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdStars className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Premium
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/reward-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaGift className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Reward
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/business-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <FaBriefcase className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                Business
              </span>
            </span>
          </Link>
          <Link
            to="/credit-card/lifestyle-credit-card"
            className="relative inline-flex items-center justify-start py-3 pl-4 pr-12 overflow-hidden font-semibold text-indigo-600 transition-all duration-150 ease-in-out rounded hover:pl-10 hover:pr-6 bg-gray-50 group"
          >
            <span class="absolute bottom-0 left-0 w-full h-1 transition-all duration-150 ease-in-out bg-indigo-600 group-hover:h-full"></span>
            <span class="absolute right-0 pr-4 duration-200 ease-out group-hover:translate-x-12">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span class="absolute left-0 pl-2.5 -translate-x-12 group-hover:translate-x-0 ease-out duration-200">
              <svg
                class="w-5 h-5 text-green-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </span>
            <span className="relative flex items-center">
              <MdCardMembership className="mr-3 text-black text-2xl" />{" "}
              <span className="text-black transition-colors duration-200 ease-in-out delay-100 group-hover:text-white">
                LifeStyle
              </span>
            </span>
          </Link>
        </div>
        <h2 className="text-center font-bold text-2xl md:text-3xl my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[400px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                <h2 className="text-center font-medium pt-5 text-lg">
                                  <span className="font-semibold text-white">816 people</span>{" "}
                                  are on call with our advisors right now
                                </h2>
                              </div> */}
              <div className="w-full mx-auto">
                {/* <Link
                  to="https://play.google.com/store/apps/details?id=com.fatakpay&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                > */}
                  <div className="w-[80%] mx-auto ">
                    {/* <img
                      src="/assets/ftak.jpg"
                      alt="Advertisement"
                      target="_blank"
                      rel="noopener noreferrer"
                    /> */}
              <AdBanner displayOrder="2" />
                  </div>
                {/* </Link> */}
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                    Know your advisor
                                  </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>
      </div>

      <div className="flex justify-center items-center  mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 ">
            What is a Travel Credit Card?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A travel credit card is a specialized financial tool designed to
            reward frequent flyers and travelers with points, miles, and
            exclusive benefits that make travel more affordable and enjoyable.
            These cards offer complimentary lounge access, accelerated rewards
            on travel bookings, foreign transaction waivers, and hotel perks —
            all while helping you save on every trip. Travel credit cards are an
            ideal choice for those who prioritize experiences and want to turn
            every journey into a rewarding one.
          </p>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4 mt-6">
          How to Apply for a Travel Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
          {/* <a
            href={ad2.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full max-w-[984px]"
          >
            <img
              src={ad2.image}
              alt={ad2.altText}
              className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
              style={{ aspectRatio: "984 / 410" }}
            />
          </a> */}
        </div>
      <div className="w-full px-2 py-6 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
        <div className="max-w-6xl mx-auto grid gap-10">
          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-sky-600" />
              <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                Documents Required to Apply for a Travel Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  PAN Card (mandatory)
                </span>
                {/* <span> PAN card, Aadhaar card, or passport.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Identity Proof (Aadhaar, Passport, or Voter ID)
                </span>
                {/* <span> Utility bills, rental agreement, or Aadhaar card.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Address Proof (Utility bills, Passport, Aadhaar)
                </span>
                {/* <span>  Latest salary slips (for salaried individuals), ITR or bank statements (for self-employed).
              </span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Latest salary slips / Form 16 / ITR (for salaried applicants)
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Business proof and ITR (for self-employed applicants)
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>

              <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                <span className="block text-gray-800 dark:text-white">
                  Recent passport-size photograph
                </span>
                {/* <span> Passport-sized photo as required by the issuer.</span> */}
              </div>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
            <div className="flex items-center gap-3 mb-6">
              <BadgeCheck className="w-8 h-8 text-emerald-600" />
              <span className="text-2xl md:text-3xl  font-bold text-gray-800 dark:text-white">
                Eligibility Required to Get a Travel Credit Card
              </span>
            </div>
            <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Applicant must be at least 21 years old (salaried) or 25
                  (self-employed)
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Minimum monthly income (varies by card, typically ₹30,000+)
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Good credit score (ideally 700+){" "}
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                <span className="block  text-gray-800 dark:text-white">
                  Indian resident with a stable financial profile
                </span>
              </div>
              <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                <span className="block  text-gray-800 dark:text-white">
                  Valid ID and address proof as per KYC norms
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 py-6 md:px-8 max-w-7xl mx-auto mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center mb-10">
          Benefits of a Fuel Credit Card
        </h2>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {benefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white shadow-md rounded-xl p-6 flex flex-col items-start gap-4 hover:shadow-xl transition duration-300"
            >
              {item.icon}
              <h3 className="text-xl font-semibold">{item.title}</h3>
              <p className="text-gray-600 text-md">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-6">
          How to Choose the Best Travel Credit Card – Key Factors to Consider
        </h2>
        {/* <p className="text-gray-600 text-base md:text-lg text-center max-w-2xl mx-auto mb-12">
    Selecting the right fuel credit card goes beyond just fuel discounts. It’s about ensuring consistent savings, ease of use, and long-term value. Here are the key elements to evaluate before making your choice:
  </p> */}

        <div className="space-y-10 divide-y divide-gray-300">
          {factors.map((item, index) => (
            <div key={index} className="flex items-start gap-5 pt-8">
              <div className="text-blue-600 shrink-0">
                <item.icon size={32} className="mt-1.5" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-1">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-gray-800">
        {/* Section Title */}
        {/* Section Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
          Why Opt for a Travel Credit Card?
        </h2>
        <p className="text-gray-600 text-base md:text-lg text-center max-w-4xl mx-auto mb-12">
          A travel credit card is ideal for frequent flyers, business travelers,
          and globetrotters who want to get more value out of every trip. If you
          often book flights, stay in hotels, or make international purchases, a
          travel card can save you money while offering elevated privileges.
          It’s also a great option for those who want access to luxury lounges,
          earn reward miles, and receive priority services — all from a single
          card.
        </p>

        {/* Benefits List */}
        {/* <ul className="text-base md:text-lg list-none space-y-4 mb-10 max-w-7xl mx-auto">
    <li className="flex gap-3 items-start">
      <span className="text-blue-600 mt-1.5">•</span>
      <span><span className="font-semibold">Daily commuters</span> who spend significantly on petrol or diesel each month.</span>
    </li>
    <li className="flex gap-3 items-start">
      <span className="text-blue-600 mt-1.5">•</span>
      <span><span className="font-semibold">Professionals or sales personnel</span> who travel frequently for work.</span>
    </li>
    <li className="flex gap-3 items-start">
      <span className="text-blue-600 mt-1.5">•</span>
      <span><span className="font-semibold">Families with multiple vehicles,</span> especially in urban areas.</span>
    </li>
    <li className="flex gap-3 items-start">
      <span className="text-blue-600 mt-1.5">•</span>
      <span><span className="font-semibold">Budget-conscious individuals</span> looking to save on unavoidable expenses like fuel.</span>
    </li>
    <li className="flex gap-3 items-start">
      <span className="text-blue-600 mt-1.5">•</span>
      <span><span className="font-semibold">People living in tier-2/tier-3 cities</span> where public transport options may be limited.</span>
    </li>
  </ul> */}

        {/* <p className="text-base md:text-lg text-center mb-14 max-w-4xl mx-auto">
    If your monthly fuel expenses exceed ₹3,000–₹5,000, opting for a fuel credit card can bring substantial monthly savings and added perks.
  </p> */}

        {/* Comparison Table */}
        <h3 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Travel Credit Card vs Normal Credit Card – A Quick Comparison
        </h3>

        {/* Styled Table */}
        <div className="overflow-x-auto w-full">
          <table className="min-w-[600px] border-separate border-spacing-y-2 text-left text-base text-gray-700">
            {/* Mobile-Friendly Table Alternative */}
            <div className="space-y-6 md:hidden">
              {[
                ["Rewards", "High on travel categories", "General rewards"],
                ["Airport Lounge Access", "Often included", "Rarely included"],
                [
                  "Foreign Transaction Markup",
                  "Lower or waived",
                  "Standard 3.5%",
                ],
                [
                  "Travel Insurance",
                  "Included in many cards",
                  "Rarely offered",
                ],
                [
                  "Miles/Points Redemption",
                  "Flights, hotels, upgrades",
                  "Shopping, cashback, vouchers",
                ],
                [
                  "Co-branding",
                  "Partnered with airlines/hotels",
                  "Usually not co-branded",
                ],
              ].map(([feature, fuel, regular], i) => (
                <div
                  key={i}
                  className="border rounded-xl p-4 shadow-sm bg-white"
                >
                  <p className="font-semibold text-gray-800 mb-2">{feature}</p>
                  <div className="text-md text-gray-700">
                    <p>
                      <span className="font-semibold">Travel Credit Card</span>{" "}
                      {fuel}
                    </p>
                    <p>
                      <span className="font-semibold">Normal Credit Card</span>{" "}
                      {regular}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <div className="hidden md:block overflow-x-auto">
              <table className="min-w-full border-separate border-spacing-y-2 text-left text-base text-gray-700">
                <thead className="bg-blue-50 text-gray-800">
                  <tr>
                    <th className="px-4 py-3 font-semibold">Feature</th>
                    <th className="px-4 py-3 font-semibold">
                      Travel Credit Card
                    </th>
                    <th className="px-4 py-3 font-semibold">
                      Normal Credit Card
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ["Rewards", "High on travel categories", "General rewards"],
                    [
                      "Airport Lounge Access",
                      "Often included",
                      "Rarely included",
                    ],
                    [
                      "Foreign Transaction Markup",
                      "Lower or waived",
                      "Standard 3.5%",
                    ],
                    [
                      "Travel Insurance",
                      "Included in many cards",
                      "Rarely offered",
                    ],
                    [
                      "Miles/Points Redemption",
                      "Flights, hotels, upgrades",
                      "Shopping, cashback, vouchers",
                    ],
                    [
                      "Co-branding",
                      "Partnered with airlines/hotels",
                      "Usually not co-branded",
                    ],
                  ].map(([feature, fuel, regular], i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? "bg-white" : "bg-gray-50"}
                    >
                      <td className="px-4 py-3 font-medium">{feature}</td>
                      <td className="px-4 py-3">{fuel}</td>
                      <td className="px-4 py-3">{regular}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </table>
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Travel;

// import React, { useEffect, useState } from 'react'
// import CardComponent from '../cardComponents/CardComponent'
// import AccordionComponent from '../accordion/AccordionComponent'
// // import { CreditCardData } from './CardData'
// import Http from '../../Http'
// import { CARD_API } from '../../Helper'
// import { Link, useLocation } from 'react-router-dom'
// const Travel = () => {
//     const [CreditCardData,setCreditCardData] = useState([])
//     const [currentPage, setCurrentPage] = useState(1);
//     const [cardsPerPage] = useState(10);
//     const location = useLocation();
//     const cardData = location.state;
//     console.log(cardData, location.state)

//     const indexOfLastCard = currentPage * cardsPerPage;
//     const indexOfFirstCard = indexOfLastCard - cardsPerPage;
//     //console.log({indexOfLastCard,indexOfFirstCard})
//     console.log({cardData})
//     const currentCards = Array.isArray(cardData) && cardData.filter((cards)=>cards.category_name==="Travel").slice(indexOfFirstCard, indexOfLastCard);
//     console.log({currentCards})
//     // const currentCards = CreditCardData.cards?.filter((card)=>card.category==="Travel").slice(indexOfFirstCard, indexOfLastCard);
//     // console.log({currentCards})

//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className='w-full flex flex-col items-center '>

//             <div className='w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600'>
//                 <h1 className='text-white md:text-7xl text-centerz-20 font-medium'>
//                     Travel Card
//                 </h1>
//                 <p className='text-gray-200 text-2xl pt-2'>Experience financial freedom and flexibility with our credit card options.</p>
//                 {/* <img className='w-[100%] h-[100%] object-cover' src='https://www.kotak.com/content/dam/Kotak/guidance/hero-slider-banner/hacks-for-being-regular-with-personal-loan-repayments-hero-desktop.jpg' alt='personalLoan' /> */}

//             </div>

//             <h1 className='text-center font-bold text-5xl my-10'>Featured Credit Cards</h1>
//             <div className='w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10'>
//                 <div className='w-fit flex flex-col gap-8'>
//                     {
//                         currentCards &&
//                         currentCards.map((item, index) => {
//                             return <> <CardComponent key={index} cardDetails={item} Card_features={item?.Card_features} fees={item?.fees} cardName={item?.title} cardImage={item?.image} rating={item?.rating} category={item?.category} status={item?.status} /> </>
//                         })
//                     }
//                 </div>

//                 <div className='w-full relative '>
//                     <div className='sticky overflow-hidden top-20 shadow-lg w-full h-[230px] rounded-2xl bg-blue-500 border flex flex-col justify-between'>
//                         <div className='w-[70%] mx-auto'>
//                             <h2 className='text-center font-medium pt-5 text-lg'><span className='font-semibold text-white'>816 people</span> are on call with our advisors right now</h2>
//                         </div>
//                         <div className='w-full mx-auto'>
//                             <div className='w-[70%] mx-auto'>
//                                 <img src='https://static.pbcdn.in/health-cdn/images/insurer-logo/quotes-logos/advisors-logo.png' alt='imgg' />
//                             </div>
//                             <div className='bg-white'>
//                                 <h3 className='text-center text-blue-500 cursor-pointer font-semibold py-2'>Know your advisor</h3>
//                             </div>
//                         </div>
//                     </div>

//                 </div>

//             </div>
//                    {/* Pagination */}
//                    <ul className='flex justify-center mt-4'>
//                 {currentCards &&
//                      CreditCardData.cards?.filter((card)=>card.category==="Credit card").length > 0 &&
//                     Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) > 1 &&
//                     Array.from({ length: Math.ceil( CreditCardData.cards?.filter((card)=>card.category==="Credit card").length / cardsPerPage) }).map((_, index) => (
//                         <li key={index} className='mx-1'>
//                             <button
//                                 className={`px-3 py-1 rounded-lg ${
//                                     currentPage === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'
//                                 }`}
//                                 onClick={() => paginate(index + 1)}
//                             >
//                                 {index + 1}
//                             </button>
//                         </li>
//                     ))}
//             </ul>

//             <div className='w-[95%] py-10'>
//                 <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
//                 <AccordionComponent />
//             </div>
//         </div>
//     )
// }

// export default Travel
